import { render, staticRenderFns } from "./PlayerVideo.vue?vue&type=template&id=457b6694&scoped=true&"
import script from "./PlayerVideo.vue?vue&type=script&lang=js&"
export * from "./PlayerVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerVideo.vue?vue&type=style&index=0&id=457b6694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b6694",
  null
  
)

export default component.exports